// Sveaskog import helpers (CLUB-189). Sveaskog is the Swedish state forestry
// company; a leased hunting ground's official boundary can be imported by the
// property's Objektnummer, which the lessee reads off their lease.

/**
 * Normalize a user-typed objektnummer: trim only.
 *
 * Leading zeros are part of the identifier, so this must never strip them, and
 * there is no case to fold — an objektnummer is digits.
 */
export function normalizeObjektnummer(raw: string): string {
  return raw.trim()
}

/**
 * A syntactically plausible objektnummer — 1 to 10 digits.
 *
 * Digits only, deliberately: the mobile client restricts this field to digits,
 * and accepting an Oma Riista-style alphanumeric code here would send it to a
 * route that can only 404.
 */
export function isValidObjektnummer(raw: string): boolean {
  return /^[0-9]{1,10}$/.test(normalizeObjektnummer(raw))
}

/**
 * Result of a Sveaskog import attempt. Success maps to created vs refreshed;
 * `not-found` is a genuinely unknown objektnummer; `error` carries the backend's
 * stable error code (e.g. `sveaskog.not_entitled`) so the UI can show it for
 * support without the shared component depending on the domain's ApiError.
 */
export type SveaskogImportResult =
  | { status: 'created' }
  | { status: 'refreshed' }
  | { status: 'not-found' }
  | { status: 'error'; code: string | null }
